
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bridge/cede",
      function () {
        return require("private-next-pages/bridge/cede.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bridge/cede"])
      });
    }
  